export default __webpack_public_path__ + "SpoqaHanSansNeo-Regular.4320485.eot";